const translations = {
  "breadCrumb.home": "მთავარი გვერდი",
  "breadCrumb.insurance-and-more": "დაზღვევა და მეტი",
  "breadCrumb.evaluations": "უკუკავშირი",
  "breadCrumb.blogs": "სიახლეები და ბლოგი",
  "breadCrumb.student": "უცხოელი სტუდენტების დაზღვევა",
  "breadCrumb.vacancy": "კარიერა",
  "breadCrumb.aboutus": "ჩვენ შესახებ",
  "breadCrumb.offices": "ოფისები",
  "breadCrumb.chat-bot": "იმედი L ბოტი",
  "breadCrumb.our-team": "ჩვენი გუნდი",
  "breadCrumb.more-about-insurance": "გაიგე მეტი დაზღვევაზე",
  "breadCrumb.legal-info": "იურიდიული ინფორმაცია",
  "breadCrumb.financial-info": "ფინანსური ინფორმაცია",
  "breadCrumb.corp-insurance": "ჯანმრთელობის კორპორატიული დაზღვევა",
  "breadCrumb.travel": "სამოგზაურო დაზღვევა",
  "breadCrumb.blog-details": "სიახლე",
  "breadCrumb.saerto": "ჯანმრთელობის ინდივიდუალური დაზღვევა",
  "breadCrumb.paymentResult": "პოლისის შეძენა",
  "breadCrumb.saerto.buypage": "პოლისის შეძენა",
  "breadCrumb.saerto.paypage": "პოლისის ფასის გადახდა",
  "breadCrumb.gephaProposal": "გეფას შეთავაზება",
  "breadCrumb.InsideTravelInsurance": "ვიზიტორების დაზღვევა საქართველოში",
  "breadCrumb.uno": "უნო / უნო+",
  "breadCrumb.uno.buypage": "პოლისის შეძენა",
  "breadCrumb.uno.paypage": "პოლისის ფასის გადახდა",
  "breadCrumb.tootsie": "Tootsie",
  "breadCrumb.privacyPolicies": "კონფიდენციალურობის პოლიტიკა",
  "breadCrumb.privacyStatement": "კონფიდენციალურობის განაცდახი",
  "breadCrumb.uno-active": "უნო აქტივი / უნო აქტივი+",
  "breadCrumb.uno-active.buypage": "პოლისის შეძენა",
  "breadCrumb.uno-active.paypage": "პოლისის ფასის გადახდა",
  "breadCrumb.uno-select": "უნო სელექთი",
  "breadCrumb.uno-select.buypage": "პოლისის შეძენა",
  "breadCrumb.uno-select.paypage": "პოლისის ფასის გადახდა",
};

export default translations;
